import React, { memo } from 'react';
import '@xyflow/react/dist/style.css';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { LdgNodeData } from './useLdgGraphData';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
export const LdgGraphNode = memo(({
  data,
  selected
}: NodeProps<LdgNodeData>) => {
  const {
    colorSet
  } = data;
  return <div className={`
        relative min-w-[240px] rounded-xl border-2 shadow-sm transition-all duration-200 bg-white
        ${selected ? `border-[${colorSet.ring}] ring-4 ring-[${colorSet.ring}]/20 shadow-md scale-105 z-10` : 'border-slate-200 hover:border-slate-300'}
      `} style={{
    borderColor: selected ? colorSet.ring : undefined
  }} data-id="element-6006" data-mp="gy7bg2srditz">
        
        {/* Target Handle (Incoming) */}
        <Handle type="target" position={Position.Left} className="w-3 h-3 border-2 border-white bg-slate-400" data-id="element-6007" data-mp="zphxo6njh7fj" />
        

        {/* Header */}
        <div className={`px-3 py-2 rounded-t-lg border-b border-slate-100 flex items-center justify-between ${colorSet.light}`} data-id="element-6008" data-mp="19l1pagv2ljyh">
          
          <div className="flex items-center gap-2" data-id="element-6009" data-mp="15tv1d9gkcn26">
            <div className={`w-2 h-2 rounded-full ${colorSet.bg}`} data-id="element-6010" data-mp="10syx2usauyw8" />
            <span className={`text-xs font-bold uppercase tracking-wider ${colorSet.text}`} data-id="element-6011" data-mp="10vthimbbcjpn">
              
              {data.module}
            </span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-6012" data-mp="rud9gl7z0tol">
            <span className="text-xs font-mono font-medium text-slate-500 bg-white px-1.5 py-0.5 rounded shadow-sm border border-slate-100" data-id="element-6013" data-mp="1ojku7r0rmyrg">
              T{data.tier}
            </span>
            <span className={`text-xs font-bold px-1.5 py-0.5 rounded ${colorSet.bg} text-white shadow-sm`} data-id="element-6014" data-mp="1fqr93cyn155o">
              
              {data.levelCode}
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="p-3" data-id="element-6015" data-mp="287adf9umzqp2">
          <div className="font-mono font-bold text-sm text-slate-800 mb-1 truncate" title={data.label} data-id="element-6016" data-mp="288lhlarzv0gp">
            
            {data.label}
          </div>
          <div className="text-xs text-slate-500 truncate" title={data.subSkill} data-id="element-6017" data-mp="2mc2ebh4e5a4v">
            
            {data.skill} • {data.subSkill}
          </div>

          {/* Status Indicator */}
          <div className="mt-3 flex items-center justify-between" data-id="element-6018" data-mp="2dkihj0jbdacj">
            <div className="flex items-center gap-1 text-xs" data-id="element-6019" data-mp="2di63gygofk4r">
              <span className="text-slate-400" data-id="element-6020" data-mp="2hksreoa88kwo">Prereqs:</span>
              <span className="font-medium text-slate-700" data-id="element-6021" data-mp="23mcjwv4jiqdh">
                {data.prerequisites.length}
              </span>
            </div>
            {!data.hasContent && <div className="flex items-center gap-1 text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded text-[10px] font-medium border border-amber-100" data-id="element-6022" data-mp="28mh2cqp0dv6c">
                <AlertTriangle className="w-3 h-3" data-id="element-6023" data-mp="1ym812yg5tjk3" />
                <span data-id="element-6024" data-mp="1yp2mas6zz8ek">No Content</span>
              </div>}
            {data.hasContent && <div className="flex items-center gap-1 text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded text-[10px] font-medium border border-emerald-100" data-id="element-6025" data-mp="3ozxguayzweat">
                <CheckCircle2 className="w-3 h-3" data-id="element-6026" data-mp="1hd5tr70fp499" />
                <span data-id="element-6027" data-mp="1hdxc3g50t5hl">Active</span>
              </div>}
          </div>
        </div>

        {/* Source Handle (Outgoing) */}
        <Handle type="source" position={Position.Right} className="w-3 h-3 border-2 border-white bg-slate-400" data-id="element-6028" data-mp="1r3gvqo0k53di" />
        
      </div>;
});
LdgGraphNode.displayName = 'LdgGraphNode';